module.exports = __webpack_public_path__ + "img/img.4f820331.png";